import { render, staticRenderFns } from "./AttachmentDeleteDialog.vue?vue&type=template&id=dbc32286"
import script from "./AttachmentDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./AttachmentDeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports